export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4801.15d80c64.jpg";